import RutaProtegida from "@components/RutaProtegida.tsx";
import WhiteZone from "@components/WhiteZone";

import Dashboards from "../pages/Dashboards";
import { DashboardsLayout } from "../layouts/DashboardsLayout";
import { General } from "../subFeatures/General";
import { Solicitudes } from "../subFeatures/Solicitudes";

export const dashboardsRoutes = {
    element: <RutaProtegida />,
    children: [
        {
            path: "dashboards",
            Component: DashboardsLayout,
            errorElement: <WhiteZone error />,
            children: [
                {
                    Component: Dashboards,
                    children: [
                        { index: true, Component: General },
                        { path: "solicitudes", Component: Solicitudes },
                        // { path: "clientes", Component: Dashboards },
                    ],
                },
            ],
        },
    ],
};
